const RestrictionsFacade = require('../../facade/restrictions/restrictions');

const ElementColorRestrictions = function (id, palettes, libraryColors, type) {
  this.elementId = id;
  this.palettes = palettes;
  this.libraryColors = libraryColors;
  this.type = (type || '') + 'colors';
};

ElementColorRestrictions.prototype.getRestrictions = function (type) {
  return RestrictionsFacade.getElementRestrictions(this.elementId, type);
};

ElementColorRestrictions.prototype.getColorsLibraryRestrictedElements = function () {
  const colorsLibraryRestrictions = this.getRestrictions(this.type + '-library')[0];

  if (colorsLibraryRestrictions && Object.keys(colorsLibraryRestrictions)?.length) {
    const palette = parseInt(colorsLibraryRestrictions.palette);
    const paletteColors = palette === 0
      ? this.libraryColors
      : _.findWhere(_.pluck(this.palettes, 'data'), { id: palette })?.colors;

    this.colors = getColors(paletteColors);

    function getColors (colorList) {
      return _.pluck(_.pluck(colorList, 'data'), 'color_code');
    }
  }
};

ElementColorRestrictions.prototype.getRestrictedColors = function () {
  this.colors = _.chain(this.getRestrictions(this.type))
    .pluck('list')
    .flatten()
    .value();

  this.getColorsLibraryRestrictedElements();

  return this.colors;
};

module.exports = ElementColorRestrictions;
